module.exports = __webpack_public_path__ + "static/media/tp3.f508c7f3.png";